import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';

// Liste des paquets de cartes de révision
export default function AdminCards() {
  const { authFetch } = useAuth();
  const [decks, setDecks] = useState(null);
  const [flash, setFlash] = useState(null);

  const load = () => authFetch('/api/admin/cards/decks')
    .then(async r => { if (!r.ok) throw new Error(await errorMessage(r)); return r.json(); })
    .then(setDecks)
    .catch(e => { setDecks([]); setFlash({ type: 'error', text: `Erreur : ${e.message}` }); });
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const notify = (type, text) => { setFlash({ type, text }); setTimeout(() => setFlash(null), 2500); };

  const togglePublish = async (d) => {
    try {
      const r = await authFetch(`/api/admin/cards/decks/${d.id}/publish`, { method: 'PATCH', body: JSON.stringify({ published: !d.published }) });
      if (!r.ok) throw new Error(await errorMessage(r));
      notify('ok', d.published ? `« ${d.title} » est repassé en brouillon` : `✓ « ${d.title} » est maintenant visible sur le site`);
      load();
    } catch (err) { setFlash({ type: 'error', text: `Impossible : ${err.message}` }); }
  };

  const remove = async (d) => {
    if (!window.confirm(`Supprimer le paquet « ${d.title} » et ses ${d.card_count} carte(s) ? Cette action est définitive.`)) return;
    try {
      const r = await authFetch(`/api/admin/cards/decks/${d.id}`, { method: 'DELETE' });
      if (!r.ok) throw new Error(await errorMessage(r));
      notify('ok', '✓ paquet supprimé');
      load();
    } catch (err) { setFlash({ type: 'error', text: `Suppression impossible : ${err.message}` }); }
  };

  return (
    <div>
      <div className="cv-admin-head">
        <h1 style={{ fontStyle: 'italic' }}>Cards</h1>
        <Link to="/admin/cards/nouveau" className="btn">+ nouveau paquet</Link>
      </div>
      <p style={{ color: 'var(--ink-soft)', marginBottom: '1.5rem' }}>
        Des cartes de révision rangées par paquets. Chaque carte : une image ou une courte vidéo (facultative), un texte,
        et une réponse au dos (facultative). Sur le site, on les fait défiler en plein écran, comme les Reels.
      </p>

      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}

      <div className="admin-list">
        {decks === null && <div className="empty-state">chargement…</div>}
        {decks && decks.length === 0 && <div className="empty-state">aucun paquet pour l'instant — créez le premier ✦</div>}
        {decks && decks.map(d => (
          <div className="admin-row deck-admin-row" key={d.id}>
            <div className="deck-admin-main">
              {d.thumb
                ? <img className="deck-admin-thumb" src={d.thumb} alt="" />
                : <span className="deck-admin-thumb deck-admin-thumb-empty" aria-hidden="true">✦</span>}
              <div>
                <div className="admin-row-title">{d.title}</div>
                <div style={{ fontSize: '.8rem', color: 'var(--ink-soft)', fontFamily: 'var(--font-mono)' }}>
                  {d.card_count} carte(s){d.video_count ? ` · ${d.video_count} vidéo(s)` : ''}{' '}
                  <span className={`qcm-status ${d.published ? 'on' : ''}`}>{d.published ? '● visible sur le site' : '○ brouillon (invisible)'}</span>
                </div>
              </div>
            </div>
            <div className="admin-row-actions">
              <button className={`btn ${d.published ? 'secondary' : ''}`} onClick={() => togglePublish(d)}>{d.published ? 'dépublier' : 'publier'}</button>
              {d.published && d.card_count > 0 && <a href={`/cards/${d.id}`} target="_blank" rel="noreferrer" className="btn secondary">voir</a>}
              <Link to={`/admin/cards/${d.id}`} className="btn secondary">modifier</Link>
              <button className="btn danger" onClick={() => remove(d)}>supprimer</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
